import React from 'react';
import { motion } from 'framer-motion';
import { useForm, Controller } from 'react-hook-form';
import { CustomInputText } from '../../../CustomInputText';
import { Grid } from '@mui/material';
import { useResponseStore } from '../../../../store/responseStore';
import { useResponses } from '../../../../hooks/encuestas/useResponses';
import { Button } from './Button';

export const UserForm = (props) => {

    const { action } = props;
    const { saveResponse } = useResponses();
    const { response } = useResponseStore();
    const { handleSubmit, control, formState: { errors }} = useForm();

    const onSubmit = async (args) => {
        const { nombre, email, celular } = args;
        saveResponse({ 
            ...response, 
            cliente: {
                nombre: nombre?.toLowerCase().trim(),
                email: email?.toLowerCase().trim(),
                celular: celular?.trim()
            } 
        });
        action();
    }

    return (
        <Grid container justifyContent='center' alignItems='center'>
            <Grid item xs={ 10 } sm={ 7 } md={ 5 } lg={ 3.5 } xl={ 2.5 }>
                <motion.form
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    onSubmit={ handleSubmit(onSubmit) }
                    style={{ background: 'rgba(255, 255, 255, .5)', borderRadius: 4, padding: 30 }}
                >
                    <Controller 
                        name='nombre'
                        control={ control }
                        defaultValue=''
                        render={({ field: { onChange, value } }) => (
                            <CustomInputText
                                label='Nombre'
                                placeholder=''
                                onChange={ onChange }
                                value={ value }
                                error={ errors?.nombre }
                                style={{ color: '#00365F' }}
                            />
                        )}

                        rules={{
                            required: 'Campo obligatorio.'
                        }}
                    />

                    <Controller 
                        name='email'
                        control={ control }
                        defaultValue=''
                        render={({ field: { onChange, value } }) => (
                            <CustomInputText
                                label='Correo electrónico'
                                placeholder=''
                                onChange={ onChange }
                                value={ value }
                                error={ errors?.email }
                                style={{ color: '#00365F' }}
                            />
                        )}

                        rules={{
                            pattern: {
                                value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                message: "Correo electrónico incorrecto.",
                            },
                        }}
                    />

                    <Controller 
                        name='celular'
                        control={ control }
                        defaultValue=''
                        render={({ field: { onChange, value } }) => (
                            <CustomInputText
                                label='Celular'
                                placeholder=''
                                type='numeric'
                                onChange={ onChange }
                                value={ value }
                                error={ errors?.celular }
                                style={{ color: '#00365F' }}
                            />
                        )}

                        rules={{
                            required: 'Campo obligatorio.',
                            pattern: {
                                value: /^[3]+[0-9]{8}[0-9]$/,
                                message: 'Número celular incorrecto'
                            }
                        }}
                    />

                    <Button 
                        title='Finalizar'
                        action={ () => false }
                        breakPoints={[ 12, 12, 12, 12 ]}
                    />
                </motion.form>
            </Grid>
        </Grid>
    )
}